// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__lsE-b","squared":"avatar_squared__4WGkN"};